import React from "react";
import Textfield from "Components/UI/Form/Textfield";
import CategoriesComboBox from "Components/Option/CategoriesComboBox";

import { useNavigate } from "react-router-dom";

import Grid from "@mui/material/Grid";

export default function OptionForm({
  formData,
  handleInputChange,
  categories,
}) {
  const navigate = useNavigate();
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <Textfield
            label="ID"
            value={formData.Id}
            // onChange={(e) => handleInputChange("Id", e.target.value)}
            disabled
            size="small"
            color="primary"
            fullWidth
            margin="dense"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Textfield
            label="Namn"
            value={formData.name}
            onChange={(e) => handleInputChange("Name", e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <CategoriesComboBox
            label={"Kategori"}
            categories={categories}
            selectedCategory={formData.categories}
            onChange={(newVal) => handleInputChange("Category", newVal)}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Textfield
            label="Värde"
            value={formData.value}
            multiline
            rows={6}
            onChange={(e) => handleInputChange("Value", e.target.value)}
          />
        </Grid>
      </Grid>
    </>
  );
}
